// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_ByteString = require("../Data.ByteString/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Functor_Tagged = require("../Data.Functor.Tagged/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Network_Ethereum_Core_BigNumber = require("../Network.Ethereum.Core.BigNumber/index.js");
var Network_Ethereum_Core_HexString = require("../Network.Ethereum.Core.HexString/index.js");
var Network_Ethereum_Core_Signatures = require("../Network.Ethereum.Core.Signatures/index.js");
var Network_Ethereum_Web3_Solidity_Bytes = require("../Network.Ethereum.Web3.Solidity.Bytes/index.js");
var Network_Ethereum_Web3_Solidity_Int = require("../Network.Ethereum.Web3.Solidity.Int/index.js");
var Network_Ethereum_Web3_Solidity_Size = require("../Network.Ethereum.Web3.Solidity.Size/index.js");
var Network_Ethereum_Web3_Solidity_UInt = require("../Network.Ethereum.Web3.Solidity.UInt/index.js");
var Network_Ethereum_Web3_Solidity_Vector = require("../Network.Ethereum.Web3.Solidity.Vector/index.js");
var Node_Encoding = require("../Node.Encoding/index.js");
var Text_Parsing_Parser = require("../Text.Parsing.Parser/index.js");
var Text_Parsing_Parser_String = require("../Text.Parsing.Parser.String/index.js");
var ABIEncode = function (toDataBuilder) {
    this.toDataBuilder = toDataBuilder;
};
var ABIDecode = function (fromDataParser) {
    this.fromDataParser = fromDataParser;
};
var uInt256HexBuilder = function (x) {
    var v = Network_Ethereum_Core_HexString.toSignedHexString(x);
    return Network_Ethereum_Core_HexString.padLeft(v.value1);
};
var toDataBuilder = function (dict) {
    return dict.toDataBuilder;
};
var toBool = function (bn) {
    return !Data_Eq.eq(Network_Ethereum_Core_BigNumber.eqBigNumber)(bn)(Data_Semiring.zero(Network_Ethereum_Core_BigNumber.semiringBigNumber));
};
var take = function (dictMonad) {
    return function (n) {
        return Data_Functor.map(Text_Parsing_Parser.functorParserT(((dictMonad.Bind1()).Apply0()).Functor0()))((function () {
            var $27 = Data_Maybe.fromJust();
            return function ($28) {
                return $27(Network_Ethereum_Core_HexString.mkHexString(Data_String_CodeUnits.fromCharArray($28)));
            };
        })())(Data_Unfoldable.replicateA(Text_Parsing_Parser.applicativeParserT(dictMonad))(Data_Unfoldable.unfoldableArray)(Data_Traversable.traversableArray)(n)(Text_Parsing_Parser_String.anyChar(Network_Ethereum_Core_HexString.stringLikeHexString)(dictMonad)));
    };
};
var uInt256HexParser = function (dictMonad) {
    return Data_Functor.map(Text_Parsing_Parser.functorParserT(((dictMonad.Bind1()).Apply0()).Functor0()))(Network_Ethereum_Core_HexString.toBigNumber)(take(dictMonad)(64));
};
var int256HexParser = function (dictMonad) {
    return Data_Functor.map(Text_Parsing_Parser.functorParserT(((dictMonad.Bind1()).Apply0()).Functor0()))(Network_Ethereum_Core_HexString.toBigNumberFromSignedHexString)(take(dictMonad)(64));
};
var int256HexBuilder = function ($copy_x) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(x) {
        var $25 = Data_Ord.lessThan(Network_Ethereum_Core_BigNumber.ordBigNumber)(x)(Data_Semiring.zero(Network_Ethereum_Core_BigNumber.semiringBigNumber));
        if ($25) {
            $copy_x = Network_Ethereum_Core_BigNumber.toTwosComplement(x);
            return;
        };
        $tco_done = true;
        return Network_Ethereum_Core_HexString.padLeftSigned(Network_Ethereum_Core_HexString.toSignedHexString(x));
    };
    while (!$tco_done) {
        $tco_result = $tco_loop($copy_x);
    };
    return $tco_result;
};
var fromDataParser = function (dict) {
    return dict.fromDataParser;
};
var fromData = function (dictABIDecode) {
    return Data_Function.flip(Text_Parsing_Parser.runParser)(fromDataParser(dictABIDecode));
};
var fromBool = function (b) {
    if (b) {
        return Data_Semiring.one(Network_Ethereum_Core_BigNumber.semiringBigNumber);
    };
    return Data_Semiring.zero(Network_Ethereum_Core_BigNumber.semiringBigNumber);
};
var bytesDecode = function (s) {
    return Data_Maybe.fromJust()(Data_Function.flip(Data_ByteString.fromString)(Node_Encoding.Hex.value)(s));
};
var bytesBuilder = (function () {
    var $29 = Data_Maybe.fromJust();
    var $30 = Data_Function.flip(Data_ByteString.toString)(Node_Encoding.Hex.value);
    return function ($31) {
        return Network_Ethereum_Core_HexString.padRight($29(Network_Ethereum_Core_HexString.mkHexString($30($31))));
    };
})();
var abiEncodeVector = function (dictABIEncode) {
    return function (dictKnownSize) {
        return new ABIEncode(function (as) {
            return Data_Foldable.foldMap(Network_Ethereum_Web3_Solidity_Vector.foldableVector)(Network_Ethereum_Core_HexString.monoidStringEq)(toDataBuilder(dictABIEncode))(as);
        });
    };
};
var abiEncodeUint = function (dictIntSize) {
    return new ABIEncode(function (a) {
        return uInt256HexBuilder(Network_Ethereum_Web3_Solidity_UInt.unUIntN(dictIntSize.KnownSize0())(a));
    });
};
var abiEncodeTagged = function (dictABIEncode) {
    return new ABIEncode((function () {
        var $32 = toDataBuilder(dictABIEncode);
        return function ($33) {
            return $32(Data_Functor_Tagged.untagged($33));
        };
    })());
};
var abiEncodeIntN = function (dictIntSize) {
    return new ABIEncode(function (a) {
        return int256HexBuilder(Network_Ethereum_Web3_Solidity_Int.unIntN(dictIntSize.KnownSize0())(a));
    });
};
var abiEncodeInt = new ABIEncode((function () {
    var $34 = Network_Ethereum_Core_BigNumber.embed(Network_Ethereum_Core_BigNumber["embedInt'"]);
    return function ($35) {
        return int256HexBuilder($34($35));
    };
})());
var abiEncodeBytesN = function (dictByteSize) {
    return new ABIEncode(function (bs) {
        return bytesBuilder(Network_Ethereum_Web3_Solidity_Bytes.unBytesN(dictByteSize.KnownSize0())(bs));
    });
};
var abiEncodeBytesD = new ABIEncode(function (bytes) {
    return Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(uInt256HexBuilder(Network_Ethereum_Core_BigNumber.embed(Network_Ethereum_Core_BigNumber["embedInt'"])(Data_ByteString.length(bytes))))(bytesBuilder(bytes));
});
var abiEncodeString = new ABIEncode((function () {
    var $36 = toDataBuilder(abiEncodeBytesD);
    return function ($37) {
        return $36(Data_ByteString.toUTF8($37));
    };
})());
var abiEncodeBool = new ABIEncode(function ($38) {
    return uInt256HexBuilder(fromBool($38));
});
var abiEncodeArray = function (dictABIEncode) {
    return new ABIEncode(function (as) {
        return Data_Semigroup.append(Network_Ethereum_Core_HexString.semigpStringEq)(uInt256HexBuilder(Network_Ethereum_Core_BigNumber.embed(Network_Ethereum_Core_BigNumber["embedInt'"])(Data_Array.length(as))))(Data_Foldable.foldMap(Data_Foldable.foldableArray)(Network_Ethereum_Core_HexString.monoidStringEq)(toDataBuilder(dictABIEncode))(as));
    });
};
var abiEncodeAlgebra = new ABIEncode(int256HexBuilder);
var abiEncodeAddress = new ABIEncode(function (addr) {
    return Network_Ethereum_Core_HexString.padLeft(Network_Ethereum_Core_Signatures.unAddress(addr));
});
var abiDecodeVector = function (dictABIDecode) {
    return function (dictKnownSize) {
        return new ABIDecode((function () {
            var len = Network_Ethereum_Web3_Solidity_Size.sizeVal(dictKnownSize)(Network_Ethereum_Web3_Solidity_Size.DLProxy.value);
            return Data_Unfoldable.replicateA(Text_Parsing_Parser.applicativeParserT(Data_Identity.monadIdentity))(Network_Ethereum_Web3_Solidity_Vector.unfoldableVector)(Network_Ethereum_Web3_Solidity_Vector.traversableVector)(len)(fromDataParser(dictABIDecode));
        })());
    };
};
var abiDecodeUint = function (dictIntSize) {
    return new ABIDecode((function () {
        var msg = function (n) {
            var size = Network_Ethereum_Web3_Solidity_Size.sizeVal(dictIntSize.KnownSize0())(Network_Ethereum_Web3_Solidity_Size.DLProxy.value);
            return "Couldn't parse as uint" + (Data_Show.show(Data_Show.showInt)(size) + (" : " + Data_Show.show(Network_Ethereum_Core_BigNumber.showBigNumber)(n)));
        };
        return Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(uInt256HexParser(Data_Identity.monadIdentity))(function (a) {
            return Data_Maybe.maybe(Text_Parsing_Parser.fail(Data_Identity.monadIdentity)(msg(a)))(Control_Applicative.pure(Text_Parsing_Parser.applicativeParserT(Data_Identity.monadIdentity)))(Network_Ethereum_Web3_Solidity_UInt.uIntNFromBigNumber(dictIntSize.KnownSize0())(Network_Ethereum_Web3_Solidity_Size.DLProxy.value)(a));
        });
    })());
};
var abiDecodeTagged = function (dictABIDecode) {
    return new ABIDecode(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Data_Functor_Tagged.tagged)(fromDataParser(dictABIDecode)));
};
var abiDecodeIntN = function (dictIntSize) {
    return new ABIDecode((function () {
        var msg = function (n) {
            var size = Network_Ethereum_Web3_Solidity_Size.sizeVal(dictIntSize.KnownSize0())(Network_Ethereum_Web3_Solidity_Size.DLProxy.value);
            return "Couldn't parse as int" + (Data_Show.show(Data_Show.showInt)(size) + (" : " + Data_Show.show(Network_Ethereum_Core_BigNumber.showBigNumber)(n)));
        };
        return Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(int256HexParser(Data_Identity.monadIdentity))(function (a) {
            return Data_Maybe.maybe(Text_Parsing_Parser.fail(Data_Identity.monadIdentity)(msg(a)))(Control_Applicative.pure(Text_Parsing_Parser.applicativeParserT(Data_Identity.monadIdentity)))(Network_Ethereum_Web3_Solidity_Int.intNFromBigNumber(dictIntSize.KnownSize0())(Network_Ethereum_Web3_Solidity_Size.DLProxy.value)(a));
        });
    })());
};
var abiDecodeInt = new ABIDecode(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Network_Ethereum_Core_BigNumber.unsafeToInt)(int256HexParser(Data_Identity.monadIdentity)));
var abiDecodeBytesN = function (dictByteSize) {
    return new ABIDecode((function () {
        var len = Network_Ethereum_Web3_Solidity_Size.sizeVal(dictByteSize.KnownSize0())(Network_Ethereum_Web3_Solidity_Size.DLProxy.value);
        var zeroBytes = Network_Ethereum_Core_HexString.getPadLength(len * 2 | 0);
        return Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(take(Data_Identity.monadIdentity)(len * 2 | 0))(function (raw) {
            return Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(take(Data_Identity.monadIdentity)(zeroBytes))(function () {
                return Control_Applicative.pure(Text_Parsing_Parser.applicativeParserT(Data_Identity.monadIdentity))(Network_Ethereum_Web3_Solidity_Bytes.update(dictByteSize.KnownSize0())(Network_Ethereum_Web3_Solidity_Bytes.proxyBytesN(dictByteSize.KnownSize0()))(bytesDecode(Network_Ethereum_Core_HexString.unHex(raw))));
            });
        });
    })());
};
var abiDecodeBool = new ABIDecode(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(toBool)(uInt256HexParser(Data_Identity.monadIdentity)));
var abiDecodeArray = function (dictABIDecode) {
    return new ABIDecode(Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Network_Ethereum_Core_BigNumber.unsafeToInt)(uInt256HexParser(Data_Identity.monadIdentity)))(function (len) {
        return Data_Unfoldable.replicateA(Text_Parsing_Parser.applicativeParserT(Data_Identity.monadIdentity))(Data_Unfoldable.unfoldableArray)(Data_Traversable.traversableArray)(len)(fromDataParser(dictABIDecode));
    }));
};
var abiDecodeAlgebra = new ABIDecode(int256HexParser(Data_Identity.monadIdentity));
var abiDecodeBytesD = new ABIDecode(Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Network_Ethereum_Core_BigNumber.unsafeToInt)(fromDataParser(abiDecodeAlgebra)))(function (len) {
    return Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(function ($39) {
        return bytesDecode(Network_Ethereum_Core_HexString.unHex($39));
    })(take(Data_Identity.monadIdentity)(len * 2 | 0));
}));
var abiDecodeString = new ABIDecode(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Data_ByteString.fromUTF8)(fromDataParser(abiDecodeBytesD)));
var abiDecodeAddress = new ABIDecode(Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(take(Data_Identity.monadIdentity)(24))(function () {
    return Control_Bind.bind(Text_Parsing_Parser.bindParserT(Data_Identity.monadIdentity))(Data_Functor.map(Text_Parsing_Parser.functorParserT(Data_Identity.functorIdentity))(Network_Ethereum_Core_Signatures.mkAddress)(take(Data_Identity.monadIdentity)(40)))(function (maddr) {
        return Data_Maybe.maybe(Text_Parsing_Parser.fail(Data_Identity.monadIdentity)("Address is 20 bytes, receieved more"))(Control_Applicative.pure(Text_Parsing_Parser.applicativeParserT(Data_Identity.monadIdentity)))(maddr);
    });
}));
module.exports = {
    fromDataParser: fromDataParser,
    toDataBuilder: toDataBuilder,
    ABIEncode: ABIEncode,
    ABIDecode: ABIDecode,
    fromData: fromData,
    bytesBuilder: bytesBuilder,
    bytesDecode: bytesDecode,
    int256HexBuilder: int256HexBuilder,
    uInt256HexBuilder: uInt256HexBuilder,
    int256HexParser: int256HexParser,
    uInt256HexParser: uInt256HexParser,
    fromBool: fromBool,
    toBool: toBool,
    take: take,
    abiEncodeAlgebra: abiEncodeAlgebra,
    abiDecodeAlgebra: abiDecodeAlgebra,
    abiEncodeBool: abiEncodeBool,
    abiDecodeBool: abiDecodeBool,
    abiEncodeInt: abiEncodeInt,
    abiDecodeInt: abiDecodeInt,
    abiEncodeAddress: abiEncodeAddress,
    abiDecodeAddress: abiDecodeAddress,
    abiEncodeBytesD: abiEncodeBytesD,
    abiDecodeBytesD: abiDecodeBytesD,
    abiEncodeString: abiEncodeString,
    abiDecodeString: abiDecodeString,
    abiEncodeBytesN: abiEncodeBytesN,
    abiDecodeBytesN: abiDecodeBytesN,
    abiEncodeVector: abiEncodeVector,
    abiDecodeVector: abiDecodeVector,
    abiEncodeArray: abiEncodeArray,
    abiDecodeArray: abiDecodeArray,
    abiEncodeUint: abiEncodeUint,
    abiDecodeUint: abiDecodeUint,
    abiEncodeIntN: abiEncodeIntN,
    abiDecodeIntN: abiDecodeIntN,
    abiEncodeTagged: abiEncodeTagged,
    abiDecodeTagged: abiDecodeTagged
};
